import { _get, _put } from "../../../../http";

// comisión de uso de la plataforma
export const getVariablesConversionMonedas = (editorialId) =>
  _get(`/editoriales/${editorialId}/variablesDeConversionDeMonedas`);

export const putVariablesConversionMonedas = (editorialId, body) =>
  _put(`/editoriales/${editorialId}/variablesDeConversionDeMonedas`, body);
